<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Agendas</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie suas agendas</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Crie, edite e acompanhe suas agendas. Use os atalhos para copiar o UUID, visualizar ou remover rapidamente.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Total de agendas</p>
        <strong class="text-lg">{{ listSchedules.length || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Ações rápidas</p>
        <div class="flex gap-2">
          <button
            class="inline-flex items-center gap-2 rounded-base bg-primary-color px-3 py-2 text-xs font-semibold text-white shadow transition hover:bg-primary-hover"
            (click)="handleGoToDocumentationApi()">
            <mat-icon>description</mat-icon>
            Doc API
          </button>
          <button
            class="inline-flex items-center gap-2 rounded-base bg-white/20 px-3 py-2 text-xs font-semibold text-light-color shadow transition hover:bg-white/30"
            (click)="openHandleNovaAgenda()">
            <mat-icon>add</mat-icon>
            Nova agenda
          </button>
        </div>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>calendar_today</mat-icon>
        <span>Listagem de agendas configuradas.</span>
      </div>
      <button
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
        (click)="openHandleNovaAgenda()">
        <mat-icon>add</mat-icon>
        Criar nova agenda
      </button>
    </div>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome da agenda</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Status</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Dias da semana</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Ações</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr *ngFor="let schedule of listSchedules" class="hover:bg-light-color/60 transition">
            <td class="px-4 py-3">
              <div class="flex items-center gap-2">
                <mat-icon>event_note</mat-icon>
                <a class="underline text-dark-color" [routerLink]="['/app/agendas/view/', schedule.id]">{{ schedule.name }}</a>
              </div>
            </td>
            <td class="px-4 py-3">
              <span class="inline-flex items-center gap-2 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                <mat-icon class="text-sm">check_circle</mat-icon>
                Ativa
              </span>
            </td>
            <td class="px-4 py-3">
              <div class="flex flex-wrap gap-1">
                <ng-container *ngFor="let config of schedule.ScheduleConfigs">
                  <ng-container *ngIf="config.isActive" [ngSwitch]="config.dayOfWeek">
                    <span *ngSwitchCase="0" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Dom</span>
                    <span *ngSwitchCase="1" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Seg</span>
                    <span *ngSwitchCase="2" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Ter</span>
                    <span *ngSwitchCase="3" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Qua</span>
                    <span *ngSwitchCase="4" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Qui</span>
                    <span *ngSwitchCase="5" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Sex</span>
                    <span *ngSwitchCase="6" class="rounded-full bg-light-color px-2 py-1 text-xs text-dark-color">Sáb</span>
                    <span *ngSwitchDefault class="rounded-full bg-red-100 px-2 py-1 text-xs text-red-700">Inválido</span>
                  </ng-container>
                </ng-container>
              </div>
            </td>
            <td class="px-4 py-3">
              <div class="flex justify-end gap-2">
                <button
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  (click)="handleRedirectVisualizationSchedule(schedule.id)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  (click)="handleCopyUUIDSchedule(schedule.id)">
                  <mat-icon>content_copy</mat-icon>
                </button>
                <button
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                  (click)="handleEditSchedule(schedule)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-hover hover:text-primary-hover"
                  (click)="handleDeleteSchedule(schedule)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!listSchedules.length">
            <td colspan="4" class="px-4 py-6 text-center text-dark-color/70">
              Nenhuma agenda cadastrada.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<ng-container *ngIf="openModalNovaAgenda">
  <app-novaagenda
    [isModalOpen]="openModalNovaAgenda"
    (closeModal)="closeHandleNovaAgenda()"
  ></app-novaagenda>
</ng-container>

<ng-container *ngIf="openModalEditSchedule">
  <app-editar-agenda
    [objectData]="selectedScheduleEdit"
    (closeModal)="handleCloseEditSchedule()"
  ></app-editar-agenda>
</ng-container>

<ng-container *ngIf="actionDeleteSchedule">
  <div class="fixed inset-0 z-50 flex items-center justify-center px-4">
    <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="handleCloseModalDeleteSchedule()"></div>
    <div class="relative w-full max-w-md rounded-2xl border border-border-color bg-white shadow-2xl">
      <div class="flex flex-col max-h-[90vh]">
        <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
          <div class="flex items-center gap-2">
            <mat-icon>warning</mat-icon>
            <h3 class="text-lg font-semibold text-dark-color m-0">Confirmar exclusão</h3>
          </div>
          <button class="rounded-lg p-2 text-dark-color/70 hover:bg-light-color/70" (click)="handleCloseModalDeleteSchedule()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="px-5 py-4 text-sm text-dark-color break-words">
          <p class="mb-3 break-words">
            Tem certeza que deseja excluir a agenda
            <strong>"{{scheduleSelectedToDelete.name}}"</strong>?
          </p>
          <div class="rounded-base border border-border-color bg-light-color/60 p-3 break-words">
            <p class="m-0 text-sm text-dark-color/80 break-words">Esta ação é irreversível. Os agendamentos e configurações serão perdidos.</p>
          </div>
        </div>

        <div class="flex flex-wrap justify-end gap-2 border-t border-border-color px-5 py-4">
          <button class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="handleCloseModalDeleteSchedule()">
            Cancelar
          </button>
          <button class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="handleActionDeleteSchedule()">
            Excluir agenda
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-loading-modal></app-loading-modal>
<app-alert></app-alert>
